class KDDropdown {
	constructor() {
		this.dropdownToggles = document.querySelectorAll(
			'[data-kd-toggle="dropdown"]'
		);
		this.initDropdowns();
		window.addEventListener( 'resize', () => this.handleViewportChange() );
	}

	initDropdowns() {
		this.dropdownToggles.forEach( ( toggle ) => {
			const targetId = toggle.getAttribute( 'data-kd-target' );
			const target = document.querySelector( targetId );
			const viewport = toggle.getAttribute( 'data-kd-viewport' );

			toggle.addEventListener( 'click', () =>
				this.toggleDropdown( target, toggle )
			);

			this.setupDropdownItemListeners( target, toggle ); // Setup listeners for dropdown items

			// Initial visibility check based on viewport size
			this.checkViewport( viewport, target, toggle );
		} );
	}

	toggleDropdown( target, toggle ) {
		const isExpanded = toggle.getAttribute( 'aria-expanded' ) === 'true';
		toggle.setAttribute( 'aria-expanded', ! isExpanded );
		target.hidden = isExpanded;
	}

	checkViewport( viewport, target, toggle ) {
		if ( ! viewport ) return; // No viewport defined, nothing to do

		const viewportWidth = parseInt( viewport, 10 );
		const isViewportBelowThreshold = window.innerWidth < viewportWidth;

		// Toggle visibility based on viewport size
		target.hidden = isViewportBelowThreshold;
		if ( ! isViewportBelowThreshold ) {
			// Ensures dropdown is visible and accessible when viewport condition is met
			target.removeAttribute( 'hidden' );
			toggle.setAttribute( 'aria-expanded', 'true' );
		} else {
			toggle.setAttribute( 'aria-expanded', 'false' );
			target.addAttribute( 'hidden' );
		}
	}

	handleViewportChange() {
		this.dropdownToggles.forEach( ( toggle ) => {
			const targetId = toggle.getAttribute( 'data-kd-target' );
			const target = document.querySelector( targetId );
			const viewport = toggle.getAttribute( 'data-kd-viewport' );
			this.checkViewport( viewport, target, toggle );
		} );
	}

	setupDropdownItemListeners( target, toggle ) {
		const links = target.querySelectorAll( 'a' );
		links.forEach( ( link ) => {
			link.addEventListener( 'click', () => {
				// Close the dropdown when a link is clicked
				target.hidden = true;
				toggle.setAttribute( 'aria-expanded', 'false' );
			} );
		} );
	}
}

document.addEventListener( 'DOMContentLoaded', () => new KDDropdown() );
